import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const STUDENT = 'student'
const INCIDENT_LEVEL = 'incident_level'
const INCIDENT_DATE = 'incident_date'
const COMMENT = 'comment'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
      required: true,
    },
    [INCIDENT_LEVEL]: {
      label: `${t('behavior.incident-level')}`,
      name: INCIDENT_LEVEL,
    },
    [INCIDENT_DATE]: {
      label: `${t('behavior.incident-date')}`,
      name: INCIDENT_DATE,
      required: true,
    },
    [COMMENT]: {
      label: `${t('common.comment')}`,
      name: COMMENT,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [INCIDENT_LEVEL]: '',
  [INCIDENT_DATE]:'',
  [COMMENT]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [STUDENT]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .required(`${t('errors.required-error-message')}`)
      .nullable(),
    [INCIDENT_DATE]: yup.string().required(t('errors.required-error-message')).nullable(),
    [COMMENT]: yup.string(),
  })

export default formModel

